/// REACT ///
import { useCallback } from "react";
import { useEffect } from "react";
/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// ACTIONS ///
import { getAutocomplete } from "api/actions/autocomplete";
/// LODASH ///
import { debounce } from "lodash";

export default function useAddressPredictions(input) {
  const dispatch = useAppDispatch();
  const { predictions } = useAppSelector(state => state.autocomplete);

  function getPlacePredictions(input) {
    dispatch(getAutocomplete(input));
  }

  const debouncedGetPlacePredictions = useCallback(
    debounce(getPlacePredictions, 500),
    []
  );

  useEffect(() => {
    debouncedGetPlacePredictions(input);
  }, [input, debouncedGetPlacePredictions]);

  return predictions;
}
